import styled from 'styled-components';

const PhotoContainer = styled.div`
    position: relative;
    background-color: #fff;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);
    box-sizing: border-box;
    margin-top: 0;
    text-align: left;
    a {
        display: block;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        border-bottom: none;
        picture {
            display: block;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 100%;
            height: inherit;
            overflow: hidden;
            img {
                display: inherit;
                width: 100%;
                object-fit: cover;
            }
        }
    }
`;
 


export default PhotoContainer;